import { alert, defaults } from '@pnotify/core';

defaults.styling = 'material';

defaults.closerHover = false;

defaults.icons = 'material';

defaults.mode = 'dark';

export default function notifyStatus(code, title = 'Request complete', message = 'Your request has been submitted successfully.', response = null,) {
    if (code < 200 || code >= 300) console.log(response.data);

    let errorFields = '';
    if (response?.data?.message) {
        // eslint-disable-next-line
        message = response.data.message;
    }
    if (response?.data?.data?.fields) {
        let {fields} = response.data.data;
        if (typeof fields === 'object' && !Array.isArray(fields) && fields !== null) fields = Object.values(fields); else if (!Array.isArray(fields)) fields = [fields];
        if (fields.length) errorFields = `\n${fields.join(' ')}`;
    }

    if (!code) {
        alert({type: 'error', title: 'Script error', text: `Refresh / Contact administrator (code: ${code})`});
    } else if (code >= 500) {
        alert({type: 'error', title: 'Server error', text: `Contact administrator (code: ${code})`});
    } else if (code === 400) {
        alert({
            type: 'notice', title: 'Bad request', textTrusted: true, text: `Oops, your request might have missing or faulty data.\n\n${message}`,
        });
    } else if (code > 400 && code < 404) {
        alert({type: 'notice', title: 'Unauthorized', text: message});
    } else if (code >= 404 && code < 409) {
        alert({type: 'error', title: 'Application error', text: `Contact administrator (code: ${code})`});
    } else if (code === 422) {
        alert({type: 'notice', title: 'Missing or wrong values', text: message + errorFields});
    } else if (code === 423) {
        alert({type: 'notice', title: 'Locked', text: `Resource locked\n${message}`});
    } else if (code >= 400) {
        alert({type: 'notice', title: 'Application error', text: `Contact administrator (code: ${code})`});
    } else if (code >= 200 && code < 300) {
        alert({
            type: 'success', title, text: message, delay: 1500,
        });
    }
}
